<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     新建模型
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog
    custom-class="dev-creater"
    :visible.sync="dialogShow"
    width="900px"
    :close-on-click-modal="false"
    :modal-append-to-body="false">

    <el-row type="flex">
      <el-col :span="4">
        <el-menu class="dev-creater-menu" :default-active="currentCreateMethod" @select="handleSelectChange">
          <el-menu-item index="1">
            <i class="el-icon-plus"></i>
            <span slot="title">新建模型</span>
          </el-menu-item>
          <el-menu-item index="2">
            <i class="el-icon-paperclip"></i>
            <span slot="title">导入模型</span>
          </el-menu-item>
          <el-menu-item index="3">
            <i class="el-icon-headset"></i>
            <span slot="title">定制模型</span>
          </el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="20" class="flex-center" style="min-height: 360px; padding: 0px 100px">
        <el-form v-if="currentCreateMethod == '1'" ref="devCreaterForm" :model="dev" :rules="rules" label-position="left" label-width="120px" style="width: 420px;">
          <el-form-item label="名称" prop="dev_name">
            <el-input v-model="dev.dev_name" clearable />
          </el-form-item>
          <el-form-item label="协议" prop="protocal">
            <el-radio-group v-model="dev.protocal" size="small">
              <el-radio-button label="MBRTU">Modbus RTU</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" :rows="2" v-model="dev.remark" />
          </el-form-item>
          <div class="flex-center" style="margin-top: 60px">
            <el-button class="extend" @click="dialogShow = false">取消</el-button>
            <el-button class="extend" type="primary" :loading="posting" @click="submit">提交</el-button>
          </div>
        </el-form>

        <div v-if="currentCreateMethod == '2'" class="flex-center column">
          <template v-if="!uploadFail" name="el-zoom-in-center">
            <b class="font-lg mb-sm">上传文件</b>
            <div class="mb flex-center align-items-center">支持 <el-link type="primary" :href="csvTempleteUrl">标准模板</el-link>、<el-link type="primary" @click="toDoc">MCGS模板</el-link> 导入模型</div>
            <el-upload
              v-loading="uploading"
              drag
              accept=".csv"
              :action="$store.state.commonStore.fileUploadUrl"
              :show-file-list="false"
              :multiple="false"
              :limit="1"
              :before-upload="beforeUpload"
              :on-error="handleUploadFail"
              :on-success="handleUploadSuccess">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                <div class="mb">将 csv 文件拖拽至此处，或</div>
                <el-button type="primary" size="mini">点击上传</el-button>
              </div>
            </el-upload>
          </template>
          <template v-else>
            <b class="font-lg">导入模型失败</b>
            <div class="mt">
              <div v-for="(item, index) in uploadFailReason" :key="index" class="text-danger">{{ item }}</div>
            </div>
            <el-button class="mt" plain size="mini" @click="resetUpload">重新上传</el-button>
          </template>
        </div>

        <div v-if="currentCreateMethod == '3'" class="flex-center column">
          <div class="mb">如果您需要定制模型服务，请联系我们</div>
          <img src="@/assets/wechat-qrcode.jpg" width="200">
        </div>
      </el-col>
    </el-row>

    
  </el-dialog>
</template>

<script>
import { postDevProfileApi, importDevApi } from '@/api/dev/devApi'

export default {
  name: 'DevCreater',

  props: {
    show: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      currentCreateMethod: '1',

      dev: {
        dev_name: '',
        protocal: 'MBRTU',
        remark: ''
      },
      rules: {
        dev_name: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        protocal: [
          { required: true, message: '不能为空', trigger: 'change' }
        ]
      },
      posting: false,

      csvTempleteUrl: 'https://api.frippler.com/attachment/docus/global/mbrtu_standard_csv_template.csv',
      uploading: false,
      uploadFail: false,
      uploadFailReason: [],
    }
  },

  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },

  created() {
  },

  methods: {
    handleSelectChange(idx) {
      this.currentCreateMethod = idx
    },

    submit() {
      this.$refs['devCreaterForm'].validate((valid) => {
        if (valid) {
          this.posting = true
          postDevProfileApi(this.dev).then(res => {
            this.posting = false
            if (!res.errno) {
              this.$message.success('新建模型成功')
              this.$emit('onSubmit')
              this.dialogShow = false
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },

    beforeUpload (file) {
      this.uploading = true
      return true
    },
    handleUploadFail(err, file, fileList) {
      this.uploading = false
      this.$message.error('文件上传失败')
    },
    handleUploadSuccess(response, file, fileList) {
      if (!response.errno) {
        importDevApi({ fileid: response.data.id }).then(res => {
          this.uploading = false
          if (!res.errno) {
            this.$message.success('导入模型成功')
            this.$emit('onSubmit')
            this.dialogShow = false
          } else {
            this.uploadFail = true
            this.uploadFailReason = res.data
          }
        })
      } else {
        this.uploading = false
        this.$message.error(response.message)
      }
    },
    resetUpload() {
      this.uploadFail = false
      this.uploadFailReason = []
    },

    toDoc() {
      window.open('https://wiki.frippler.com/#/docs/fs/fcs/46')
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-menu-item:hover, /deep/.el-menu-item:focus {
  background-color: #f5f7fa;
}
/deep/.el-dialog__body {
  padding: 10px 20px 30px;
}
.dev-creater {
  .el-dialog__body {
    padding-top: 0;
  }
  .dev-creater-menu {
    height: 100%;
    .el-menu-item.is-active {
      background-color: rgba(7, 193, 96, 0.05);
    }
  }
}
</style>
